<template>
    <modal
        :id="modalId"
        title="Configure Bathrom Features
"
        @ok.prevent="configureBathromFeatures"
    >
        <busy-modal :show="busy" />
        <b-table
            outlined
            striped
            :items="place.bathroom_features || []"
            :fields="columns"
            caption-top
            tbody-tr-class="invoice-print-body-tr"
            thead-tr-class="invoice-print-head-tr"
            class="mb-0"
            :show-empty="true"
        >
            <template #cell(qty)="data">
                <div class="d-flex bed-setup-counter">
                    <b-button
                        class="minus-button"
                        @click="decreaseQuantity(data)"
                        variant="default"
                    >
                        -
                    </b-button>
                    <b-form-input
                        class="qty-input"
                        v-model="data.item.qty"
                        type="number"
                    ></b-form-input>
                    <b-button
                        @click="increaseQuantity(data)"
                        class="plus-button"
                        variant="default"
                    >
                        +
                    </b-button>
                </div>
            </template>
        </b-table>
    </modal>
</template>

<script>
import api from '../../../../api';
import { formatResponseError } from '../../../../utils/api';
import Modal from '../../../generic/modal/modal.vue';
import { RENTAL_PROPERTY_SETUP_DETAILS_ENDPOINT } from '../../../../endpoints';
import BusyModal from '../../../generic/busy-modal/busy-modal.vue';
export default {
    components: {
        Modal,
        BusyModal,
    },
    data() {
        return {
            busy: false,
        };
    },
    props: ['modalId', 'place'],
    inject: ['propertyId'],
    computed: {
        columns() {
            return [
                {
                    key: 'name',
                    label: 'Type',
                },
                {
                    key: 'qty',
                    label: 'Quantity',
                },
            ];
        },
    },
    methods: {
        async configureBathromFeatures() {
            try {
                this.busy = true;
                await api.post(
                    `${RENTAL_PROPERTY_SETUP_DETAILS_ENDPOINT(
                        this.propertyId
                    )}edit-bathroom-features/`,
                    this.place
                );
                this.$bvModal.hide(this.modalId);
                this.successToast({ text: 'Bathrom Features successfully saved.' });
            } catch (e) {
                const { generic } = formatResponseError(e);
                this.errorToast({
                    text: generic || 'Could not configure bathrom features',
                });
            } finally {
                this.busy = false;
            }
        },
        decreaseQuantity(data) {
            if (data.item.qty > 0) {
                data.item.qty -= 1;
            }
        },
        increaseQuantity(data) {
            if (data.item.qty == 0) {
                data.item.qty = Number(data.item.qty) + 1;
            }
        }        
    },
};
</script>

<style lang="scss">
.bed-setup-counter {
    .minus-button {
        border-radius: 0.25em !important;

        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
    }
    .plus-button {
        border-radius: 0.25em !important;

        border-top-left-radius: 0 !important;
        border-bottom-left-radius: 0 !important;
    }

    .qty-input {
        border-radius: 0 !important;
        border-right: 0 !important;
        border-left: 0 !important;
        text-align: center;
    }
}
</style>